document.addEventListener('DOMContentLoaded', function () {
    "use strict";
    
    // Get all tab links and tab contents
    const tabLinks = document.querySelectorAll('.zwssgr-tabs-nav a');
    const tabContents = document.querySelectorAll('.zwssgr-widget-container .zwssgr-tab-content');

    // Add event listener to each tab link
    tabLinks.forEach(function (tabLink, index) {
        tabLink.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default anchor behavior

            // Hide all tab contents
            tabContents.forEach(function (tabContent) {
                tabContent.style.display = 'none';
            });

            // Show the clicked tab content
            const target = document.querySelector(tabLink.getAttribute('href'));
            target.style.display = 'block';

            // Remove 'active' class from all tab links
            tabLinks.forEach(function (link) {
                link.parentElement.classList.remove('active');
            });

            // Add 'active' class to the clicked tab link
            tabLink.parentElement.classList.add('active');
        });
    });

    // Show the first tab by default and mark it as active
    if (tabContents.length > 0) {
        tabContents[0].style.display = 'block';
    }
    if (tabLinks.length > 0) {
        tabLinks[0].parentElement.classList.add('active');
    }
});
